import { render } from "./PdfViewer.vue?vue&type=template&id=1fb1ad4e&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=1fb1ad4e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb1ad4e"],['__file',"src/pages/components/templates/pdfViewer/PdfViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fb1ad4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fb1ad4e', __exports__)) {
    console.log('reload')
    api.reload('1fb1ad4e', __exports__)
  }
  
  module.hot.accept("./PdfViewer.vue?vue&type=template&id=1fb1ad4e&scoped=true", () => {
    console.log('re-render')
    api.rerender('1fb1ad4e', render)
  })

}


export default __exports__